var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loader"},[_c('svg',{staticClass:"loader",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"100%","height":"100%","viewBox":"-50 -50 200 200"}},[_c('circle',{staticClass:"circle",attrs:{"cx":"50","cy":"50","r":"50","stroke":"black","stroke-width":"2"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }